module.exports = {
      id: "mobile-share-usage",
      viewBox: "0 0 16.211 17.807",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#mobile-share",
      toString: function () {
        return this.url;
      }
    }